<template>
    <div class="container enterphonenumber hmi ">
        <VehicleLink></VehicleLink>
        <div>
            <!-- <div class="title tm-top">(000) 000-0000</div>
            <div class="dialpad">
                <div class="row justify-content-center title">
                    <div class="col-1">
                        <button type="button" class="btn">1</button>
                    </div>
                    <div class="col-1">
                        <button type="button" class="btn">2</button>
                    </div>
                    <div class="col-1">
                        <button type="button" class="btn">3</button>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-1">
                        <button type="button" class="btn">4</button>
                    </div>
                    <div class="col-1">
                        <button type="button" class="btn">5</button>
                    </div>
                    <div class="col-1">
                        <button type="button" class="btn">6</button>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-1">
                        <button type="button" class="btn">7</button>
                    </div>
                    <div class="col-1">
                        <button type="button" class="btn">8</button>
                    </div>
                    <div class="col-1">
                        <button type="button" class="btn">9</button>
                    </div>
                </div> -->
                <!-- <div class="row justify-content-center">
                    <div class="col-1">
                        <button type="button" class="btn">0</button>
                    </div>
                </div> -->
            <!-- </div> -->

            <div class="my-3"></div>
            <div class="row">
                <div class="col">
                    <router-link to="/scanfour">
                        <button type="button" class="btn btn-primary send-button">Next</button>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VehicleLink from '../components/VehicleLink'
    export default {
        name: "enterphonenumber",
        components:{
            VehicleLink
        }
    }
</script>

<style scoped>
    .hmi{
        /* height:540px; */
        /*background-image: linear-gradient(90deg, #733AEA 0%, #217CF6 100%);*/
        background-color: #F8F8FA;
        border: 1px solid #979797;
        color:white;
    }
    .tm-top{
        margin-top:107px;
    }
    .title{
        font-family: ToyotaType-Semibold;
        font-size: 40px;
        color: #1D1F20;
        letter-spacing: -0.5px;
        text-align: center;
    }
    .subtext{
        color: rgb(147, 147, 162);
        font-family: ToyotaType-Regular;
        font-size: 24px;
        font-weight: normal;
        letter-spacing: -0.5px;
        text-align: center;
    }
    .send-button{
        background: linear-gradient(-135deg, rgb(66, 129, 255) 0%, rgb(117, 117, 255) 100%);
        border-radius: 37px;
        height: 74px;
        width: 269px;
        color: rgb(255, 255, 255);
        font-family: ToyotaType-Semibold;
        font-size: 24px;
        font-weight: 600;
        letter-spacing: -0.5px;
        text-align: center;
    }
    .dialpad {
        justify-content: center;
    }
    a:link {
        color:#FFFFFF;
    }
</style>
